/**
 * Dashboard / Favorites / profile layout colors.
 *
 * Peter's annotated spec (2026-10-05). Import these instead of hardcoding hex.
 * Do not invent close variants — change this file if a surface color must change.
 */

export const PRAIRI_SURFACES = {
  /** Left profile card fill. */
  profileCard: '#303030',

  /** Page / feed behind the card and “Specially for you”. */
  page: '#1d1d1d',

  /** Pitch-deck / right-pane grey. */
  pitchDeck: '#262626',

  /** Column gutter and top/bottom bars. */
  divider: '#000000',

  /**
   * Pending deal-tracker disc and unfinished connector line.
   * Must stay the same hex — never a cooler grey.
   */
  trackerPending: '#696969',

  /**
   * Completed deal-tracker check / completed line / brand green.
   * Same as emerald-500. Peter’s screenshot sampled `#91cf50`; the platform token is `#92d050`.
   */
  trackerComplete: '#92d050',
} as const;

export type PrairiSurface = keyof typeof PRAIRI_SURFACES;

/** Catalog row title (“Specially for you”) — Rubik, not bold. */
export const PRAIRI_CATALOG_LABEL = {
  fontFamily: 'Rubik, sans-serif',
  fontWeight: 400,
} as const;
